import debtorService from '../../services/debtor-service';

const state = () => ({

    loading: false,
    debtors: [],
    error: null
})

const actions = {
    getAll({ commit }) {
        commit('Loading', true);

        debtorService.getAll()
            .then(
                debtors => {
                    //console.log(debtors);
                    commit('Success', debtors.data);

                },
                error => commit('Failure', error)
            );
    },
    add({ commit, state }, data) {
        debtorService.create(data)
            .then(
                response => {
                    if (response.status == 200) {
                        data.id = response.data.id;
                        state.debtors.unshift(data);
                        commit('Failure', null)
                    }
                },
                error => commit('Failure', error)
            )

    },
    delete({ commit, state }, data) {
        debtorService.delete(data.debtor.id)
            .then(
                response => {
                    //state.debtors.splice(data.index, 1)
                    commit('Remove', data.index)
                    commit('Failure', null)
                },
                error => commit('Failure', error)
            )
    },
    update({ commit, state }, data) {
        Object.assign(state.debtors[data.index], data.debtor);

        // debtorService.update(data.debtor.id, data.debtor)
        //     .then(
        //         success => {

        //             commit('Failure', null)
        //         },
        //         error => commit('Failure', error)
        //     )

    },
    readdSaleItemToStock({ commit }, data) { //incase sale debtor is removed from sale list this will readd it to the stock debtors
        commit('Readd', data)
    },
    removeSaleItemFromStock({ commit }, index) {
        commit('Remove', index)
    }
}


const mutations = {
    Loading(state, status) {
        state.loading = status;
    },
    Success(state, debtors) {
        state.debtors = debtors;
        state.loading = false;
    },
    Failure(state, error) {
        state.error = error;
    },
    Deleted_debtor(state, payload) {
        //to be implemented for undo feature later
    },
    Remove(state, index) {
        state.debtors.splice(index, 1)
    }

}

const getters = {
    DEBTORS: state => {
        return state.debtors
    },

    DEBTOR_ERROR: state => {
        return state.error
    },
    DEBTORS_LOADING: state => {
        return state.loading
    },


}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}